
import { Investment } from "@/types/investment";
import { formatDate, formatCurrency } from "./utils";

interface OriginalContractTermsProps {
  investment: Investment;
}

const OriginalContractTerms = ({ investment }: OriginalContractTermsProps) => {
  // Calculate original balance after down payment
  const originalBalance = investment.originalSalesPrice && investment.originalDownPayment 
    ? investment.originalSalesPrice - investment.originalDownPayment 
    : null;

  return (
    <div className="bg-blue-50 p-6 rounded-lg border border-blue-200">
      <h4 className="text-lg font-semibold text-blue-800 mb-4">Original Contract Terms</h4>
      <div className="space-y-3">
        {investment.salesDate && (
          <div className="flex justify-between">
            <span className="text-sm text-gray-600">Sales Date:</span>
            <span className="font-semibold">{formatDate(investment.salesDate)}</span>
          </div>
        )}
        {investment.originalSalesPrice && (
          <div className="flex justify-between">
            <span className="text-sm text-gray-600">Sales Price:</span>
            <span className="font-semibold">{formatCurrency(investment.originalSalesPrice)}</span>
          </div>
        )}
        {investment.originalDownPayment && (
          <div className="flex justify-between">
            <span className="text-sm text-gray-600">Down Payment:</span>
            <span className="font-semibold">{formatCurrency(investment.originalDownPayment)}</span>
          </div>
        )}
        {originalBalance && (
          <div className="flex justify-between">
            <span className="text-sm text-gray-600">Original Balance:</span>
            <span className="font-semibold">{formatCurrency(originalBalance)}</span>
          </div>
        )}
        {investment.originalTerm && (
          <div className="flex justify-between">
            <span className="text-sm text-gray-600">Original Term:</span>
            <span className="font-semibold">{investment.originalTerm} months</span>
          </div>
        )}
        <div className="flex justify-between">
          <span className="text-sm text-gray-600">Interest Rate:</span>
          <span className="font-semibold">{investment.interestRate}%</span>
        </div>
        <div className="flex justify-between">
          <span className="text-sm text-gray-600">Monthly Payment:</span>
          <span className="font-semibold">{formatCurrency(investment.monthlyPayment)}</span>
        </div>
        {investment.hasBalloonPayment && investment.balloonPaymentAmount && (
          <div className="flex justify-between">
            <span className="text-sm text-gray-600">Balloon Amount:</span>
            <span className="font-semibold">{formatCurrency(investment.balloonPaymentAmount)}</span>
          </div>
        )}
      </div>
    </div>
  );
};

export default OriginalContractTerms;
